<template>
    <el-dialog
            :visible.sync="show"
            width="50%"
            title="添加配置"
            :before-close="closeDialog"
            :close-on-click-modal="false"
    >

        <el-form>



            <el-form-item
                    label="状态:"
                    label-width='120px'
            >
                <el-select
                        v-model="submit_data.status"
                        placeholder="请选择状态"
                        style="width: 150px; margin-right: 20px;"
                        clearable
                >
                    <el-option
                            label="启用"
                            value="1"
                    >
                    </el-option>
                    <el-option
                            label="禁用"
                            value="0"
                    >
                    </el-option>
                </el-select>

            </el-form-item>

            <el-form-item
                    label-width='120px'
            >


                <el-button @click="addRules" type="text" style="float: right">+增加设置</el-button>



            </el-form-item>


            <el-table
                    :data="tableData"
                    style="width: 100%"
                    ref="multipleTable"
                    header-cell-class-name="table-header"
            >


                <el-table-column
                        prop="day_array"
                        label="起始公斤数(不包含)"
                >

                    <template slot-scope="props">

                        <el-input v-model="props.row.weight_start_array" placeholder="起始公斤数"></el-input>

                    </template>


                </el-table-column>

                <el-table-column
                        prop="driver_insurance_array"
                        label="截止公斤数(包含)"
                >
                    <template slot-scope="props">

                        <el-input v-model="props.row.weight_end_array" placeholder="截止公斤数"></el-input>

                    </template>

                </el-table-column>

                <el-table-column
                        prop="driver_insurance_array"
                        label="金额"
                >
                    <template slot-scope="props">

                        <el-input v-model="props.row.money_array" placeholder="金额"></el-input>

                    </template>

                </el-table-column>

                <el-table-column
                        label="操作"
                        width="80"
                >

                    <template slot-scope="props">

                        <el-button type="text" style="color: red" @click="del(props.row)">删除</el-button>

                    </template>

                </el-table-column>

            </el-table>




            <!--      <el-form-item label-width='120px'>-->

            <!--        <el-button @click="addRules">增加规则</el-button>-->

            <!--      </el-form-item>-->

        </el-form>
        <span
                slot="footer"
                class="dialog-footer"
        >
      <el-button @click="closeDialog">取 消</el-button>
            <!--      <el-button-->
            <!--        type="primary"-->
            <!--        @click="onSubmit"-->
            <!--      >确 定</el-button>-->
      <submitBtn @onSubmitDig="onSubmitDig" @toJSON="toJSON" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="true"></submitBtn>
    </span>
    </el-dialog>
</template>

<script>
    var _this;
    export default {
        props: {
            isShow: Boolean,
            data: ''
        },
        watch: {
            isShow(newData, oldData) {
                _this.show = true;
            }
        },
        data() {
            return {
                show: false,


                submit_url:'/legwork/addLegworkWeightSubmit',
                // 表单数据
                submit_data: {
                    weight_start_array: '',
                    status: '',
                    weight_end_array:'',
                    money_array:''
                },

                // 表格数据
                tableData:[{
                    weight_start_array:'',
                    weight_end_array:'',
                    money_array:''
                }],



                submit_rules: {


                    status: {
                        placeholder: '状态',
                        rules: {
                            required: true,
                            message: '状态错误',
                            regulation: 'special',
                            rulesData: '0|1'
                        }
                    }
                }
            };
        },
        created() {
            _this = this;
        },
        methods: {
            del(obj) {

                // 获取对应下标
                var index = _this.tableData.indexOf(obj);

                this.tableData.splice(index, 1);

            },

            addRules() {
                this.tableData.push({
                    weight_start_array:'',
                    weight_end_array:'',
                    money_array:''
                });
            },

            // 关闭方法
            closeDialog() {
                _this.show = false;
                _this.submit_data = {
                    weight_start_array: '',
                    status: '',
                    weight_end_array:'',
                    money_array:''
                };
                _this.tableData = [{
                    weight_start_array:'',
                    weight_end_array:'',
                    money_array:''
                }]
            },
            toJSON(){
                var weight_start_array = [];
                var weight_end_array = [];
                var money_array = [];

                for (var i = 0;i < _this.tableData.length;i++){

                    weight_start_array.push(_this.tableData[i].weight_start_array);

                    weight_end_array.push(_this.tableData[i].weight_end_array);

                    money_array.push(_this.tableData[i].money_array);

                }

                _this.submit_data.weight_start_array = JSON.stringify(weight_start_array);
                _this.submit_data.weight_end_array = JSON.stringify(weight_end_array);
                _this.submit_data.money_array = JSON.stringify(money_array);

                console.log( _this.submit_data);

            },
            // 提交
            onSubmitDig() {

                // 触发父组件自定义事件刷新表格
                _this.$emit('onSubmit');
                _this.closeDialog();


            }
        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>